import { Skeleton } from '@/_components/ui/skeleton'
import { TabNav } from '@/features/_components/ui/tab-nav'
import { useIsRouteActive } from '@/features/_hooks/use-is-route-active'
import { Link } from '@tanstack/react-router'
import { ChevronLeft } from 'lucide-react'

interface CompanyHeaderLoadingProps {
  showBack?: boolean
  showTabs?: boolean
}

export function CompanyHeaderLoading({
  showBack = false,
  showTabs = true,
}: CompanyHeaderLoadingProps) {
  const isFacilityRouteActive = useIsRouteActive('companies', 'facilities')
  const isPersonRouteActive = useIsRouteActive('companies', 'persons')
  const isUsersRouteActive = useIsRouteActive('companies', 'users')
  const isSettingsRouteActive = useIsRouteActive('companies', 'settings')

  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex flex-col gap-2">
        {showBack && (
          <Link
            to="/companies"
            className="flex w-fit items-center gap-0.5 text-xs text-muted-foreground transition-colors hover:text-foreground"
          >
            <ChevronLeft size={14} />
            Voltar
          </Link>
        )}
        <Skeleton className="h-8 w-48" />
      </div>
      {showTabs && (
        <TabNav
          items={[
            { label: 'Unidades', href: '#', isActive: isFacilityRouteActive },
            { label: 'Pacientes', href: '#', isActive: isPersonRouteActive },
            { label: 'Usuários', href: '#', isActive: isUsersRouteActive },
            { label: 'Configurações', href: '#', isActive: isSettingsRouteActive },
          ]}
        />
      )}
    </div>
  )
}
